'use client';
import React from 'react';
import { SectionTitle } from '@benzinga/core-ui';
import type { News } from '@benzinga/basic-news-manager';

import type { BaseQuotePageProps } from '../../../../../src/utils/quote/types';
import QuotePageTitleLink from '../_components/QuotePageTitleLink';
import FinancialsPageContent from '../../../../../src/components/Quote/FinancialsPageContent';
import { QuoteNewsFeed } from '../../../../../src/components/Quote/QuoteNewsFeed';
import DrilldownFooter from '../../../../../src/components/Quote/DrilldownFooter';
import { QuoteFooter } from '../../../../../src/components/Quote/QuoteFooter';

interface FinancialsContentProps extends BaseQuotePageProps {
  financialsNews: News[];
}

const FinancialsContent: React.FC<FinancialsContentProps> = ({
  financialsNews,
  metaProps,
  profile,
  symbol,
}) => {
  return (
    <>
      <div className="main-div flex flex-col gap-y-8">

        <div className="flex flex-col gap-2">
          <SectionTitle level={1} uppercase={false}>
            <QuotePageTitleLink title={metaProps.title} symbol={symbol} />
          </SectionTitle>
          <p className="section-description">{metaProps.description}</p>
        </div>

        <FinancialsPageContent symbol={symbol} />

        <DrilldownFooter
          isETF={profile.isETF}
          leftSection={
            financialsNews.length > 0 ? (
              <div className="flex flex-col gap-2">
                <SectionTitle level={2} size="xl" uppercase={false}>
                  Earnings &amp; Guidance News
                </SectionTitle>
                <QuoteNewsFeed
                  nodes={financialsNews}
                  query={{ channels: [16888, 16889], pageSize: 6, tickers: symbol }}
                  seeMoreEnabled={true}
                  showLoadMoreButton={true}
                />
              </div>
            ) : null
          }
          peers={profile.peers}
          peerSymbols={profile.peerSymbols}
          symbol={symbol}
          type={profile.schedule?.type ?? null}
        />
        <QuoteFooter activeTab="financials" />
      </div>
    </>
  );
};

export default FinancialsContent;
